export default __webpack_public_path__ + "static/media/rp41.29255711.jpg";